import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loan-options-header-section"
}
const _hoisted_2 = { class: "toggle-sections" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "loan-options-header-section" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = {
  key: 0,
  class: "tooltip-wrapper"
}
const _hoisted_7 = { class: "repayment-type-tooltip-text" }
const _hoisted_8 = {
  key: 0,
  class: "description"
}
const _hoisted_9 = {
  key: 1,
  class: "description"
}

import { computed } from "vue";
import { useStore } from "vuex";
import Icon from "@/components/shared/Icon.vue";
import Tooltip from "@/components/pel-loan-configuration/Tooltip.vue";
import useHtmlUtilities from "@/use/htmlUtilities";
import { RateTypeSection } from "@/models/loanConfiguration";


export default /*@__PURE__*/_defineComponent({
  __name: 'PelLoanOptionsHeader',
  props: {
  rateTypeActive: {
    type: Number,
    required: true,
    default: 1,
  },
  ratePlanCount: {
    type: Number,
    required: true,
    default: 0,
  },
  isMobile: {
    type: Boolean,
    required: true,
  },
},
  emits: ["setCurrentRateType"],
  setup(__props, { emit: __emit }) {

const { isColorDark } = useHtmlUtilities();

const props = __props;

const emit = __emit;

const store = useStore();

const dark = computed<boolean>(() => isColorDark(store.state.lenderData.primaryColor));

const rateTypeSections = computed<Array<RateTypeSection>>(
  () => store.state.loanConfigurationModule.loanOptionsConfiguration.rateTypeSections,
);

const mobile = computed<boolean>(() => props.isMobile);

const showToggle = computed<boolean>(() => rateTypeSections.value?.length > 1);

const headerText = computed<string>(() =>
  mobile.value
    ? `${currentRateType.value?.rateTypeName} Rates`
    : `${currentRateType.value?.rateTypeName} Interest Rate`,
);

const currentRateType = computed<RateTypeSection | undefined>(() =>
  rateTypeSections.value?.find((r: RateTypeSection) => props.rateTypeActive === r.rateTypeId),
);

const otherRateType = computed<string>(
  () =>
    rateTypeSections.value
      ?.find((r: RateTypeSection) => props.rateTypeActive !== r.rateTypeId)
      ?.rateTypeName?.toLowerCase() || "variable",
);

const descriptionText = computed<string>(() =>
  props.ratePlanCount <= 1
    ? `Select your repayment type below or view your ${otherRateType.value} rate options on the other tab.`
    : `Select a term from your options below or view your ${otherRateType.value} rate options on the other tab.`,
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["loan-options-header-container", { dark: dark.value, mobile: __props.isMobile }])
  }, [
    (rateTypeSections.value && showToggle.value && rateTypeSections.value?.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rateTypeSections.value, (rateType) => {
              return (_openBlock(), _createElementBlock("div", {
                key: rateType.rateTypeName,
                class: _normalizeClass(["section-toggle", { active: __props.rateTypeActive === rateType.rateTypeId }]),
                onClick: ($event: any) => (_ctx.$emit('setCurrentRateType', rateType.rateTypeId))
              }, [
                _createElementVNode("p", null, _toDisplayString(rateType.rateTypeName) + " Rates", 1)
              ], 10, _hoisted_3))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h3", null, [
          _createTextVNode(_toDisplayString(headerText.value) + " ", 1),
          (showToggle.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                _createVNode(Tooltip, {
                  "screen-padding": 0,
                  class: "right-auto"
                }, {
                  toggle: _withCtx(() => [
                    _createElementVNode("sup", null, [
                      _createVNode(Icon, {
                        icon: "info",
                        class: "toggle-icon"
                      })
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("p", null, _toDisplayString(currentRateType.value?.rateTypeName) + " Rates", 1),
                      _createElementVNode("p", null, _toDisplayString(currentRateType.value?.rateTypeDescription), 1)
                    ])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (showToggle.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(descriptionText.value), 1))
        : (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(currentRateType.value?.rateTypeDescription), 1))
    ])
  ], 2))
}
}

})